import {
  subHours,
  differenceInHours,
  parseISO,
  differenceInMinutes,
} from 'date-fns'

import { addTimeZone, getCookie } from '@/resources/utils/global'

import OrderStatusEnum from '@/resources/enums/orderStatus'
import { deliveryTypeEnum } from '@/resources/enums/deliveryTypes'

export const twoHoursSinceTheOrderWasAccepted = ({ date }) => {
  const currentHour = new Date()
  const pocAcceptedOrderHour = subHours(parseISO(date), 3)
  const elapsedTimeTheOrderWasAccepted = differenceInHours(
    currentHour,
    pocAcceptedOrderHour
  )
  return elapsedTimeTheOrderWasAccepted >= 2
}

const orderIsPending = lastStatus => lastStatus === OrderStatusEnum.PENDING

const orderIsTranfered = lastStatus => lastStatus === OrderStatusEnum.TRANSFERED

const getStatusCodeAcceptedInfos = lastStatus =>
  lastStatus === OrderStatusEnum.POC_ACCEPTED

export const hasCompletedStatus = lastStatus => {
  const completedStatusCode = {
    DELIVERED: OrderStatusEnum.DELIVERED,
    USER_CANCELLED: OrderStatusEnum.USER_CANCELLED,
    POC_REJECT: OrderStatusEnum.POC_REJECT,
    POC_EXPIRED: OrderStatusEnum.POC_EXPIRED,
    POC_ABANDONED: OrderStatusEnum.POC_ABANDONED,
    SUSPECT: OrderStatusEnum.SUSPECT,
  }

  return lastStatus in completedStatusCode
}

const isLastStatusInTheLastHour = (statusHistory, lastStatus) => {
  const lastStatusDateStr = statusHistory.find(
    ({ status }) => status === lastStatus
  )?.date
  if (!lastStatusDateStr) return false

  const lastStatusDate = addTimeZone(lastStatusDateStr)
  const now = new Date()
  const difference = differenceInMinutes(now, lastStatusDate)

  return difference >= 0 && difference <= 60
}

export const canViewPhone = (
  statusHistory,
  lastStatus = '',
  hasChopp,
  deliveryType
) => {
  if (hasChopp) return true

  if (hasCompletedStatus(lastStatus)) {
    return isLastStatusInTheLastHour(statusHistory, lastStatus)
  }

  if (orderIsTranfered(lastStatus)) return false

  if (orderIsPending(lastStatus)) return false

  const statusCodeAcceptedInfos = getStatusCodeAcceptedInfos(lastStatus)

  if (
    statusCodeAcceptedInfos &&
    twoHoursSinceTheOrderWasAccepted(statusHistory[0]) &&
    deliveryType !== deliveryTypeEnum.SCHEDULED
  ) {
    return false
  }

  return true
}

export const hasOnlinePaymentSectionEnabled = () => {
  const ONLINE_PAYMENT_COOKIE = 'online_payment_enabled'
  const cookie = getCookie(ONLINE_PAYMENT_COOKIE)

  if (cookie) {
    return cookie === 'true'
  }

  return false
}
